import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult, HealthcheckType } from '../types'
import { getBillingProblem } from './billingUtils'
import { getOnboardingStepAssignee } from '../utils/onboardingWorkflowUtils'

export const useBillingStatus = (
  org: OrganizationDetailFragment | null | undefined,
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult | null => {
  if (!org) return null
  const billingProblem = getBillingProblem(org)
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, OnboardingStepType.ConnectBilling)
  const healthcheckTitle = 'Billing'

  const baseProperties = {
    assignee,
    healthcheckTitle,
    primary: healthcheckTitle,
    healthcheckType: HealthcheckType.ConnectBilling,
  } as const

  if (!billingProblem) {
    return {
      status: 'complete',
      secondary: org?.billing?.hasUnifiedBilling ? 'Payment method is active' : 'Payment methods are active',
      ...baseProperties,
    }
  }

  switch (billingProblem) {
    case 'missing_source':
    case 'error':
      return {
        status: 'partial',
        secondary: 'Connect billing methods for remaining pay groups',
        ...baseProperties,
      }
    case 'expired':
      return {
        status: 'incomplete',
        secondary: 'Update expired payment card(s)',
        ...baseProperties,
      }
    default:
      return {
        status: 'incomplete',
        secondary: 'Configure and connect billing methods',
        ...baseProperties,
      }
  }
}
